/*
 * Copyright (c) 2021 Adres.
 * All rights reserved.
 */
const styles = theme => ({
  lightThinValue: {
    fontWeight: '600 !important',
    // lineHeight: '1.5',
    // fontSize: '1rem',
    fontSize: 16,
  },
  avatarDiv: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    alignContent: 'center',
  },
  lightThinLable: {
    fontWeight: '400 !important',
    fontSize: 14,
  },
  textRow: {
    fontSize: 12,
    fontWeight: 400,
  },
  accordianHeaderWithData: {
    display: 'flex',
    alignItems: 'center',
    // width: '60%',
    // padding: '10px',
  },
  flexCenter: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    '& $ownerAvatarimg': {
      marginRight: '12px',
      height: '64px',
      width: '64px',
      background: '#EBEEF3',
    },
    '& $textRow': {
      paddingBottom: '0',
    },
  },
  container: {
    padding: 24,
    background: theme.palette.primary.white,
  },
  viewText: {
    color: '#237E7C',
    fontWeight: 400,
    fontSize: 16,
  },
  avatarImg: {
    height: 54,
    width: 54,
    marginRight: 12,
  },
  dropDownDivider: {
    height: 8,
    width: '100%',
    background: '#EBEEF3',
  },
  body1: {
    color: '#130F26',
    // fontSize: '1.125rem',
    fontSize: 16,
    fontWeight: '600 !important',
    [theme.breakpoints.down('md')]: {
      fontSize: '1rem',
    },
  },
  viewAllDiv: {
    color: '#342D3D',
    height: 72,
    borderTop: '1px solid #CED1D6',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '10px 16px',
    [theme.breakpoints.up('md')]: {
      //   borderBottom: '1px solid #CED1D6',
    },
    '& h1': {
      marginBottom: '0',
      marginRight: '8px',
      fontSize: '16px',
      '& $dangerText': {
        color: '#D2374F',
      },
    },
    '& $textGray': {
      fontSize: '14px',
      marginTop: '6px',
    },
  },
  padding: {
    paddingLeft: 62,
  },
  //   divider: {
  //     borderBottom: '1px solid #EBEEF3',
  //     paddingTop: 8,
  //     paddingBottom: 8,
  //   },
  cardDivider: {
    borderBottom: '1px solid #EBEEF3',
    // paddingTop: 8,
    // paddingBottom: 8,
  },
  innercontent: {
    padding: '24px',
  },
  '@media (max-width: 600px)': {
    divider: {
      borderBottom: '1px solid #EBEEF3',
      '&:last-child': {
        borderBottom: 'none',
      },
    },
    avatarImg: {
      height: 40,
      width: 40,
      marginRight: 12,
    },
    container: {
      paddingTop: 13,
      paddingBottom: 13,
      paddingLeft: 16,
      paddingRight: 16,
    },
    ownerAvatarimg: {
      marginRight: 12,
    },
    bankPadding: {
      paddingTop: 16,
      paddingBottom: 16,
    },
    lightThinValue: {
      fontWeight: '500 !important',
      fontSize: 12,
    },
    lightThinLable: {
      fontWeight: '400 !important',
      fontSize: 12,
    },
    paperCardFrame: {
      marginBottom: '0px',
      borderRadius: '0px',
      overflow: 'hidden',
    },
    padding: {
      paddingLeft: 0,
    },
    innercontent: {
      padding: '16px',
    },
  },
});

export default styles;
